class PasswordResetSent2UsersController {
  static controller($scope, $state) {
    'ngInject';
  };
}

export default PasswordResetSent2UsersController.controller;



// WEBPACK FOOTER //
// ./src/users/forgot-password/password-reset-sent2.users.controller.js